import {
    IEmailRequest,
    IEmailRequestAbrindoCaso,
    IEnviarEmail,
    IGerarPDF,
} from "../../../Interfaces/Geral/Email/EmailInterface";
import {
    EnviarEmailAnexoAbrindoCasoService,
    EnviarEmailAnexoService,
    EnviarEmailService,
    ExportarDocumentoHtmlParaPdfServices,
    GerarDocumentosTemplateServices,
} from "../../../Services/Geral/Email/EmailService";
import { Controller } from "../../Controller";

export async function EnviarEmailController(requestBody: IEnviarEmail) {
    return Controller(EnviarEmailService(requestBody));
}

export async function EnviarEmailAnexoController(requestBody: IEmailRequest) {
    return Controller(EnviarEmailAnexoService(requestBody));
}

export async function EnviarEmailAnexoAbrindoCasoController(
    requestBody: IEmailRequestAbrindoCaso,
    ID_CONTA: number,
    idTipoCaso: number
) {
    return Controller(
        EnviarEmailAnexoAbrindoCasoService(requestBody, ID_CONTA, idTipoCaso)
    );
}

export async function ExportarDocumentoHtmlParaPdfController(
    requestBody: IGerarPDF
) {
    return Controller(ExportarDocumentoHtmlParaPdfServices(requestBody));
}

export async function GerarDocumentosTemplateController(
    idDocumentoTemplate: number,
    idCaso: number
) {
    return Controller(
        GerarDocumentosTemplateServices(idDocumentoTemplate, idCaso)
    );
}
